import { animate, style, transition, trigger } from '@angular/animations';

export const accordionTop = trigger('accordionTop', [
  transition(':enter', [
    style({
      height: 0,
    }),
    animate('.35s ease-out', style({
      height: '*',
    }))
  ]),
  transition(':leave', [
    animate('.35s ease-out', style({
      height: 0,
    })),
  ]),
]);
